import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import cookies from 'react-cookies';
import { getClstag } from '@/util/index';
import style from './index.module.scss';
import History from '../history';

import {
  delHistory,
  getSearchHistoryList,
  addSearchHistory,
  getAcquireAssociativeWords,
  isSkuId,
} from '@/api/newApi/search';
import { message } from 'antd';
import { buildSearchListHistoryLocation } from '@/pages/SearchList/utils/searchListUrl';
import { useTranslation } from 'react-i18next';
import { customClickReportSimple } from '@/dataPort';
import { reportSearchButtonClick as reportVerticalSearchButtonClick } from '@/dataPort/verticalSearchReport';
interface IAppProps {
  input_color: string;
  hot_word_id: string;
  hot_color: string;
  search_text: string;
  search_btn_color: string;
  search_size: number;
  search_color: string;
  is_search_hot: boolean;
  bg_color: string;
  is_bg_color: boolean;
  isLenovo: boolean;
  clientOpenWindow: boolean;
  location?: any;
  onInputValueChange?: (value: string) => void;
  getSearchReportData?: () => {
    uuid: string;
    pvId: string;
    logId: string;
  };
}

interface SearchAttemptResponse {
  success?: boolean;
  value?: string[];
  msg?: string;
  message?: string;
}

const SUGGEST_DEBOUNCE_DELAY = 300;

const Search: React.FC<IAppProps> = props => {
  const { search_btn_color, isLenovo, getSearchReportData } = props;
  const [isShow, setIsShow] = useState(false); //是否展示联想词列表
  const [isShowHistory, setIsShowHistory] = useState(false); //是否展示搜索记录列表
  const [sIndex, setSIndex] = useState(-1); //下拉框键盘操作第几个
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [inputVal, setInputVal] = useState((location as any).query || ''); //文本框输入的值
  // 同步实时输入（含路由回填和清空），供相邻的行家导购按钮直接发起检索。
  useEffect(() => {
    props.onInputValueChange?.(inputVal);
  }, [inputVal, props.onInputValueChange]);
  const resultCount = useSelector((state: any) => state?.SearchList?.pageInfo?.maxResultCount ?? 0);
  const searchSubmitting = useSelector((state: any) => state?.SearchList?.searchSubmitting ?? false);
  const userInfo = useSelector((state: any) => state?.User?.data?.[0] || {});
  const userPin = userInfo?.pin || '';
  const contractId = userInfo?.contractNum || '';
  const isEnglish = i18n.language === 'en';
  const [searchList, setSearchList] = useState<string[]>([]); //搜索词联想数据
  const [historyList, setHistoryList] = useState<string[]>([]); // 历史记录数据
  const [isFocus, setIsFocus] = useState(false); //是否获取焦点
  const [islocation, setIsLocation] = useState(cookies.load('stationType')); //本土还是跨境
  const suggestTimerRef = useRef<number | null>(null);
  const latestSuggestKeywordRef = useRef('');
  const suggestRequestSeqRef = useRef(0);
  const mountedRef = useRef(true);

  const clearSuggestTimer = () => {
    if (suggestTimerRef.current !== null) {
      window.clearTimeout(suggestTimerRef.current);
      suggestTimerRef.current = null;
    }
  };

  const cancelSuggestTask = () => {
    clearSuggestTimer();
    latestSuggestKeywordRef.current = '';
    suggestRequestSeqRef.current += 1;
  };

  const getRequestErrorMessage = (error: unknown): string => {
    if (error && typeof error === 'object') {
      const msg = (error as { msg?: unknown; message?: unknown }).msg;
      const errorMessage = (error as { msg?: unknown; message?: unknown }).message;
      if (typeof msg === 'string' && msg) return msg;
      if (typeof errorMessage === 'string' && errorMessage) return errorMessage;
    }

    return TLT('网络异常~');
  };

  // 跳转
  const openWinPage = async (inputVal: string) => {
    cancelSuggestTask();
    setIsShow(false);
    setInputVal(inputVal);
    await addSearchHistory(inputVal);
    const result = (await isSkuId(inputVal)) as any;
    if (result.success && result.value) {
      window.location.href = `${window.location.origin}/sku/${result.value}`;
      return;
    }
    history.replace(
      buildSearchListHistoryLocation({
        key: inputVal,
        pageNo: 1,
        sort: 0,
      }, {}, {
        query: inputVal,
        searchTriggerTs: Date.now(),
      }),
    );
  };

  //  获取搜索历史记录
  const searchHistoryFn = () => {
    const getData = async () => {
      const result: any = (await getSearchHistoryList()) as any; // [""]
      try {
        if (result?.value?.length) {
          const value = result?.value.filter((i: string) => i);
          setHistoryList(value);
          !inputVal && setIsShowHistory(true); // 展示搜索历史弹框
        }
      } catch (e) {
        setHistoryList(result?.value || []);
        setIsShowHistory(true); // 展示搜索历史弹框
      }
    };
    getData();
  };

  //  删除历史记录
  const delSearchHistoryFn = (num: number, data: object) => {
    const newHistory = [...historyList];
    const getData = async () => {
      const result: any = (await delHistory(data)) as any;
      if (result.success) {
        if (num != -1) {
          newHistory.splice(num, 1);
          setHistoryList(newHistory);
        } else {
          setHistoryList([]);
        }
      }
    };
    getData();
  };

  //搜索联想数据
  const searchOne = (val: string) => {
    const keyword = val.trim();
    latestSuggestKeywordRef.current = keyword;
    clearSuggestTimer();

    if (!keyword) {
      suggestRequestSeqRef.current += 1;
      setSearchList([]);
      setIsShow(false);
      return;
    }

    // 联想词跟随键盘输入，防抖后再请求；旧关键词响应回来时丢弃，避免下拉列表闪回。
    const requestSeq = suggestRequestSeqRef.current + 1;
    suggestRequestSeqRef.current = requestSeq;
    suggestTimerRef.current = window.setTimeout(() => {
      getAcquireAssociativeWords(keyword)
        .then(res => {
          const result = res as SearchAttemptResponse;
          if (!mountedRef.current || latestSuggestKeywordRef.current !== keyword || suggestRequestSeqRef.current !== requestSeq) {
            return;
          }

          if (result.success) {
            setSearchList(Array.isArray(result.value) ? result.value.filter(Boolean) : []);
            setIsShow(true);
          } else {
            message.error(result.msg || result.message || TLT('网络异常~'));
          }
        })
        .catch((error: unknown) => {
          if (mountedRef.current && latestSuggestKeywordRef.current === keyword && suggestRequestSeqRef.current === requestSeq) {
            message.error(getRequestErrorMessage(error));
          }
        });
    }, SUGGEST_DEBOUNCE_DELAY);
  };

  //搜索框获取焦点的时候增加交互
  const focusWith = () => {
    // const url: any = GetRequest();
    setInputVal(inputVal);
    setSIndex(-1); //清除键盘选中
    //销端改造下掉历史记录
    searchOne(inputVal);
    return;
    if (inputVal !== '') {
      setIsShowHistory(false); // 关闭搜索历史弹框
      setIsShow(true);
    } else {
      setIsShow(false); // 关闭关键词联想弹框
      setIsShowHistory(true);
    }
  };
  // 点击账号其他位置收起退出弹框
  const handleHid = (e: any) => {
    //为了解决有时候className获取出一个对象 导致监听事件失效
    if (typeof e?.target?.className !== 'string') {
      return;
    }
    const str = e?.target?.className?.split('_')[1];
    if (str !== 'historyList' && str !== 'searchInput' && str !== 'hotHistoryList') {
      setIsShowHistory(false);
    }
  };
  //搜索框输入change事件
  const changeFn = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    // const url: any = GetRequest();
    //销端改造下掉历史记录
    if (isLenovo) {
      searchOne(e.target.value);
    }

    setInputVal(e.target.value);
    setSIndex(-1); //清除键盘选中

    if (e.target.value !== '') {
      setIsShowHistory(false); // 关闭搜索历史弹框
    } else {
      //销端改造下掉历史记录
      return;
      searchHistoryFn(); //获取下搜索历史的数据
      setIsShow(false); // 关闭关键词联想弹框
      setIsShowHistory(true); // 展示搜索历史弹框
    }
  };

  //获取光标事件
  const focus = () => {
    // 暂时隐藏搜索历史 start
    // const dom: any = document.getElementById('G_searchbg');
    // if (dom) {
    //   dom.style.color = 'rgba(0, 0, 0, 0.26)';
    // }
    // if (inputVal == '') {
    //   searchHistoryFn();
    // }
    // focusWith();
    // 暂时隐藏搜索历史 end

    setIsFocus(true);
  };
  //离开光标事件
  const blurs = () => {
    const dom: any = document.getElementById('G_searchbg');
    if (dom) {
      dom.style.color = 'rgba(0, 0, 0, 0.46)';
    }
    // 搜索栏默认搜索直到数组开始切换
    setTimeout(() => {
      setSIndex(-1); //清除键盘选中
      setIsShow(false);
      setIsFocus(false);
    }, 300);
  };

  //搜索联想列表，键盘上下键操控
  const handleKeyUp = (e: any) => {
    if (!isShow) return;
    const keyCode = e.keyCode;
    // 上下箭头
    if (keyCode == 38 || keyCode == 40) {
      const newList: any = searchList.length > 0 && isShow ? [...searchList] : [...historyList];
      //如果没有联想词，禁止键盘上下操作
      if (newList.length <= 0) return;

      let index = sIndex;
      if (keyCode == 38) {
        //方向键向上
        index--;
        if (index < 0) {
          index = newList.length - 1;
        }
      }
      if (keyCode == 40) {
        //方向键向下
        index++;
        if (index > newList.length - 1) {
          index = 0;
        }
      }

      setSIndex(index);
      if (searchList.length > 0 && isShow) {
        setInputVal(newList[index]);
      } else {
        setInputVal(newList[index]);
      }
    }
  };
  // 本场景搜索
  const handleSceneSearch = (inputVal: any) => {
    if (searchSubmitting) {
      return;
    }
    getSearchReportData?.();
    openWinPage(inputVal);
  };

  //回车事件
  const handleKeyDown = (e: any) => {
    const keyCode = e.keyCode;
    console.log(keyCode);
    if (keyCode == 13) {
      if (searchSubmitting) {
        return;
      }
      const currentReportData = getSearchReportData?.();
      customClickReportSimple('Search_SearchButton', {
        keyword: inputVal,
        pin: userPin,
        timestamp: Date.now(),
        result_count: resultCount,
      });
      reportSearchButtonClick(currentReportData);
      //回车键
      if (inputVal != '') {
        e.target.blur();
        openWinPage(inputVal);
      }
    }
  };
  //搜索按钮点击点击埋点方法
  const reportSearchButtonClick = (reportData?: { uuid: string; pvId: string; logId: string }) => {
    const currentReportData = reportData || getSearchReportData?.();
    if (!currentReportData) {
      return;
    }

    reportVerticalSearchButtonClick({
      keyword: inputVal,
      input_word: '',
      pin: userPin,
      uuid: currentReportData.uuid,
      pvid: currentReportData.pvId,
      logid: currentReportData.logId,
      source: 1, // 
      timestamp: new Date().getTime(), // 点击事件时间戳
      ext: '',
      contractid: contractId,
    });
  }
  //点击搜索按钮
  const handleClick = () => {
    if (searchSubmitting) {
      return;
    }
    const currentReportData = getSearchReportData?.();
    customClickReportSimple('Search_SearchButton', {
      keyword: inputVal,
      pin: userPin,
      timestamp: Date.now(),
      result_count: resultCount,
    });
    reportSearchButtonClick(currentReportData);
    openWinPage(inputVal);
  };
  //点击联想列表
  const lenovoFn = (value: string) => {
    if (searchSubmitting) {
      return;
    }
    getSearchReportData?.();
    openWinPage(value);
  };
  useEffect(() => {
    mountedRef.current = true;
    document.addEventListener('click', handleHid);
    return () => {
      mountedRef.current = false;
      document.removeEventListener('click', handleHid);
      // 组件卸载时让已发出的联想词请求失效，避免异步回调更新已卸载组件。
      cancelSuggestTask();
    };
  }, []);
  useEffect(() => {
    if (location.pathname === '/page/list') {
      let searchValue = (location as any).query || '';
      if (!searchValue) {
        searchValue = window.localStorage.getItem('iv') || '';
      }
      if (searchValue && !(location as any).query) {
        openWinPage(searchValue);
      }
      // window.localStorage.setItem('iv', searchValue);
      setInputVal(searchValue);
    } else {
      setInputVal('');
    }
  }, [location]);

  return (
    <div className={`${style.seach_con}`}>
      <div
        className={`${style.searchTop}`}
        onMouseLeave={() => {
          // !isFocus && setIsShowHistory(false);
        }}
        onMouseEnter={() => {
          // 暂时隐藏搜索记录
          // isFocus && !inputVal && setIsShowHistory(true);
        }}
      >
        {/* {isFocus && inputVal != '' ? (
          <i
            className={`${style.searchIconClose}`}
            onClick={() => {
              setInputVal('');
            }}
          ></i>
        ) : (
          ''
        )} */}

        <input
          clstag={getClstag('Search_SearchInputBox', 'gc')}
          placeholder={TLT('请输入商品关键词、商品编码、物料编码...')}
          className={`${style.searchInput} `}
          type="text"
          value={inputVal}
          data-track={JSON.stringify({
            eventId: 'Search_SearchInputBox',
          })}
          onChange={e => {
            changeFn(e);
          }}
          onFocus={() => {
            //销端改造下掉历史记录联想词
            focus();
          }}
          onBlur={() => {
            blurs();
          }}
          onKeyUp={e => {
            handleKeyUp(e);
          }}
          onKeyDown={e => {
            handleKeyDown(e);
          }}
        ></input>
        <div
          clstag={getClstag('Search_SearchButton', 'gc')}
          className={`${style.searchBtn} ${isEnglish ? style.searchBtnEn : ''} ${searchSubmitting ? style.searchBtnDisabled : ''}`}
          onClick={(e) => {
            handleClick();
          }}
        >
          <i className={`iconFont icon-search ${style.searchBtnIcon}`}></i>
          <span>{TLT(`搜索`)}</span>
        </div>
        {isShowHistory ? (
          <History
            historyList={historyList}
            searchHistoryFnEvent={delSearchHistoryFn}
            downIndex={sIndex}
            handleSceneSearch={handleSceneSearch}
          ></History>
        ) : (
          ''
        )}
        {/* 联想词 */}
        {isFocus && isShow && inputVal && searchList && searchList?.length ? (
          <ul className={`${style.searchList}`}>
            {searchList.map((item, index) => {
              return (
                <li
                  key={index}
                  className={`${sIndex == index ? style.active : ''}`}
                  onClick={() => {
                    lenovoFn(item);
                  }}
                >
                  <div
                    className={`${style.item}`}
                    dangerouslySetInnerHTML={{
                      __html: item.replace(new RegExp(inputVal, 'g'), `<span>${inputVal}</span>`),
                    }}
                  ></div>
                </li>
              );
            })}
          </ul>
        ) : (
          ''
        )}
      </div>{' '}
    </div>
  );
};
export default Search;
